import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const Products = [
  { value: '19', plan: 'Bolso Protegido' },
  { value: '62', plan: 'Empleo Protegido' },
  { value: '12', plan: 'Accidentes Personales' },
  { value: '8', plan: 'Seguro Hogar' },
  { value: '161', plan: 'Tecnología Portátil' },
  { value: '159', plan: 'Notebook Protegida' },
];

const ProductPath = ({ productType, plan }) => {
  const additionalData = useSelector((state) => state.firstStep.additionalData);
  const userContainProduct = useSelector((state) => state.firstStep.userContainProduct);
  const firstStep = useSelector((state) => state.firstStep.firstStep);
  const [product, setProduct] = useState('');

  const capitalizeText = (text) => {
    const lowerCaseText = String(text).toLowerCase();
    return lowerCaseText ? lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1) : '';
  };


  useEffect(() => {
    if (productType && !userContainProduct) {
      setProduct(productType);
    };
    if (!productType && userContainProduct) {
      const planSection = Products?.find((e) => e.value === firstStep.codsec)?.plan
      setProduct(planSection);
    }
  }, [])

  useEffect(() => {
    if (localStorage.getItem('productType') === null) {
      localStorage.setItem('productType', JSON.stringify(firstStep.codsec));
    } else {
      const product = JSON.parse(localStorage.getItem('productType'));
      const planSection = Products.find((e) => e.value === product)?.plan
      setProduct(planSection);
    }
  }, []);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', position: 'relative', marginLeft: '15px', marginTop: '10px' }}>
        {
          <p style={{ fontSize: '0.7rem', color: 'RGB (105 105 105)' }}>
            {productType || product} /
          </p>
        }
        {
          plan && (
            <p style={{ fontSize: '0.7rem', color: 'RGB (105 105 105)', textTransform: "capitalize" }}>
              {capitalizeText(plan)} /
            </p>
          )
        }
        <p style={{ fontSize: '0.7rem', color: 'RGB (105 105 105)' }}>
          {additionalData !== '' && capitalizeText(additionalData)}
        </p>
      </div>
    </>
  );
};

export default ProductPath;
